import { useMutation, useQueryClient } from '@tanstack/react-query';

type Params = {
  customFieldIds: number[];
};

/**
 * candidate_form_itemsをcustom_field_id配列で一括作成する
 */
export default function useBulkCreateCandidateFormItems() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async ({ customFieldIds }: Params) => {
      const response = await fetch('/agent/api/candidate_forms/candidate_form_items/bulk_create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ custom_field_ids: customFieldIds }),
      });

      if (!response.ok) {
        let errorMessage = '項目の追加に失敗しました';
        try {
          const errorData = await response.json();
          errorMessage = errorData?.message || errorData?.errors?.[0] || errorMessage;
        } catch {
          // noop
        }
        throw new Error(errorMessage);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
